import React from 'react';
import { Folder, Settings, Sun, Moon, Search } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import { useManuals } from '../../contexts/ManualsContext';

export const Header = () => {
    const { darkMode, setDarkMode } = useTheme();
    const { userRole } = useAuth();
    const { setIsSidebarOpen, searchQuery, setSearchQuery, setShowAdminPanel, showAdminPanel } = useManuals();

    return (
        <header className={`${darkMode ? 'bg-gray-800 border-b border-gray-700' : 'bg-white shadow-sm border-b border-gray-200'}`}>
            <div className="flex items-center justify-between px-4 md:px-6 h-16">
                <button
                    onClick={() => setIsSidebarOpen(true)}
                    className={`p-2 rounded-lg transition-colors md:hidden ${
                        darkMode
                            ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700'
                            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-100'
                    }`}
                >
                    <Folder className="w-6 h-6" />
                </button>
                <div className="flex items-center space-x-4">
                    {userRole === 'admin' && (
                        <button
                            onClick={() => setShowAdminPanel(!showAdminPanel)}
                            className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                                darkMode
                                    ? showAdminPanel
                                        ? 'bg-blue-900 text-blue-300'
                                        : 'hover:bg-gray-700 text-gray-200'
                                    : showAdminPanel
                                        ? 'bg-blue-100 text-blue-700'
                                        : 'hover:bg-gray-100 text-gray-700'
                            }`}
                        >
                            <Settings className="w-4 h-4" />
                            <span className="font-medium hidden sm:inline">Админ-панель</span>
                        </button>
                    )}
                    <div className="relative">
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Поиск по мануалам..."
                            className={`hidden md:block pl-10 pr-4 py-2 w-64 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                                darkMode
                                    ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
                                    : 'border border-gray-300'
                            }`}
                        />
                        <Search className={`hidden md:block absolute left-3 top-2.5 w-5 h-5 ${
                            darkMode ? 'text-gray-400' : 'text-gray-400'
                        }`} />
                    </div>
                    <button
                        onClick={() => setDarkMode(!darkMode)}
                        className={`p-2 rounded-lg transition-colors ${
                            darkMode
                                ? 'text-yellow-300 hover:bg-gray-700'
                                : 'text-gray-600 hover:bg-gray-100'
                        }`}
                    >
                        {darkMode ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
                    </button>
                </div>
            </div>
        </header>
    );
};